import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const fetchAllDashbaordData = () => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.dashboard.fetchAllDashbaordData()
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_DASHBOARD_DATA_FAILED,
              reject: actionTypes.FETCH_DASHBOARD_DATA_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_DASHBOARD_DATA_LOADING);
  const success = res => action(actionTypes.FETCH_DASHBOARD_DATA_SUCCESS, res);
  return request();
};

export const fetchAllCafeAdminDashbaordData = () => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.dashboard.fetchAllCafeAdminDashbaordData()
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_CAFE_ADMIN_DASHBOARD_DATA_FAILED,
              reject: actionTypes.FETCH_CAFE_ADMIN_DASHBOARD_DATA_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_CAFE_ADMIN_DASHBOARD_DATA_LOADING);
  const success = res => action(actionTypes.FETCH_CAFE_ADMIN_DASHBOARD_DATA_SUCCESS, res);
  return request();
};